import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  GetDoormanByBuildingIdCommand,
  GetDoormanByDocumentCommand,
  GetAllDoormansCommand,
  UpdateDoormanCommand,
  CreateDoormanCommand,
  UpdateStatusDoormanCommand,
} from './doorman.commands';
import {
  GotDoormanByBuildingIdEvent,
  GotDoormanByDocumentEvent,
  GotAllDoormansEvent,
  UpdatedDoormanEvent,
  CreatedDoormanEvent,
  UpdatedStatusDoormanEvent,
} from './doorman.events';

@Injectable()
export class DoormanEffects {
  prefix = 'doorman';
  getDoormanByBuildingIdCommand: Observable<Action<string>> & CreateEffectMetadata;
  getDoormanByDocumentCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAllDoormansCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateDoormanCommand: Observable<Action<string>> & CreateEffectMetadata;
  createDoormanCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateStatusDoormanCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.getDoormanByBuildingIdCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetDoormanByBuildingIdCommand,
      GotDoormanByBuildingIdEvent,
      this.prefix,
    );
    this.getDoormanByDocumentCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetDoormanByDocumentCommand,
      GotDoormanByDocumentEvent,
      this.prefix,
    );
    this.getAllDoormansCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetAllDoormansCommand,
      GotAllDoormansEvent,
      this.prefix,
    );
    this.updateDoormanCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdateDoormanCommand,
      UpdatedDoormanEvent,
      this.prefix,
    );
    this.createDoormanCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      CreateDoormanCommand,
      CreatedDoormanEvent,
      this.prefix,
    );
    this.updateStatusDoormanCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdateStatusDoormanCommand,
      UpdatedStatusDoormanEvent,
      this.prefix,
    );
  }
}
